import React from 'react'
import { connect } from "react-redux";



class MMOLB extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {

        } = this.props

        return (
            <>
                <div className='methodsActive LINE'>
                    <p className='lineTitle'>ฝากเงินผ่านไลน์นางฟ้า</p>
                    <div className='line'>
                        <span className='lineQRcode'></span>
                    </div>
                    <p className='lineText'>
                        {`1.ขอรับเลขที่บัญชีทาง Line ID: @funangel \n2.แจ้งยอดฝากเงิน \n3.รอทีมงานปรับยอดเงิน 5 - 15 นาที \n4.ร่วมสนุกกับทาง Fun88 ได้ทันที`}
                    </p>
                    <div className='lineSteps'>
                        <span className='lienIcon'></span>
                    </div>
                </div>
                <p className='lineTripsTitle'>
                    การแจ้งเตือน：
                    <p>ฝากเงินขั้นต่ำ 200 บาท สูงสุด 100,000 บาท ต่อ 1 รายการ</p>
                </p>

            </>
        );
    }
}

const mapStateToProps = state => ({

});
const mapDispatchToProps = {
    // SetDepositNextStep: (data = false) => SetDepositNextStep(data)
};
export default connect(mapStateToProps, mapDispatchToProps)(MMOLB);


const styles = {
    trips: {
        color: '#999',
        fontSize: 14,
        paddingLeft: 10,
        paddingTop: 5,
    },
    tripsTitle: {
        paddingLeft: 10,
        paddingTop: 17,
        fontSize: 14,
        color: '#666',
    },
    lineIcons: {
        width: 350,
        height: 320,
    },
    lineText: {
        color: '#666',
        fontSize: 12,
        paddingTop: 20,
    },
    line: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lineIcon: {
        width: 113,
        height: 228,
    },
    title: {
        color: '#00A6FF',
        fontSize: 14,
        paddingBottom: 20,
    },
    methods: {
        flex: 1,
        borderRadius: 8,
        padding: 8,
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: '#fff',
        marginTop: 20,
    },
}

